import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import TypewriterText from "../components/TypeWriterText";

const pages = [
  { title: "Curator's Foreword", path: "/foreword-bitcointech" },
  {
    title: "Day 71: A Primer on What Bitcoin Is and How It Works",
    path: "/bitcoin-tech-page-71",
  },
  {
    title: "Day 72: Private-Public Keys & Addresses",
    path: "/bitcoin-tech-page-72",
  },
  {
    title: "Day 73: Understanding UTXO Model and Bitcoin's Transactions",
    path: "/bitcoin-tech-page-73",
  },
  {
    title: "Day 74: Bitcoin’s Scripting Language, OP_CODES and Scripts",
    path: "/bitcoin-tech-page-74",
  },
  {
    title: "Day 75: Digital Signatures",
    path: "/bitcoin-tech-page-75",
  },
  {
    title: "Day 76:  Anatomy of A Bitcoin Block & its Propagation",
    path: "/bitcoin-tech-page-76",
  },
  {
    title: "Day 77:  Bitcoin Mining and Proof of Work",
    path: "/bitcoin-tech-page-77",
  },
  {
    title: "Day 78: Set-Up Your Regtest Bitcoin Node(Hands-On)",
    path: "/bitcoin-tech-page-78",
  },
  {
    title: "Day 79: Create and Broadcast A Bitcoin Transaction(Hands-On)",
    path: "/bitcoin-tech-page-79",
  },
  {
    title: "Day 80:  A Tour of Bitcoins Key Concensus Rules",
    path: "/bitcoin-tech-page-80",
  },
  {
    title: "Day 81:  Understanding BIPs",
    path: "/bitcoin-tech-page-81",
  },
  {
    title: "Day 82:  Segwit ",
    path: "/bitcoin-tech-page-82",
  },
  {
    title: "Day 83:  Taproot & Schnorr Signature",
    path: "/bitcoin-tech-page-83",
  },
  {
    title: "Day 84: The Peer-to-Peer Network Architecture of Bitcoin",
    path: "/bitcoin-tech-page-84",
  },
  {
    title: "Day 85: Mempool and Transaction Relay Policies",
    path: "/bitcoin-tech-page-85",
  },
  {
    title: "Day 86: Difficulty Adjustment and Block Timing Mechanism",
    path: "/bitcoin-tech-page-86",
  },
  {
    title: "Day 87: Forks in Bitcoin – Soft Forks vs Hard Forks",
    path: "/bitcoin-tech-page-87",
  },
  {
    title: "Day 88: Compact Block Relay and Bandwidth Optimization",
    path: "/bitcoin-tech-page-88",
  },
  {
    title: "Day 89: Bitcoin is Money",
    path: "/bitcoin-tech-page-89",
  },
  {
    title: "Day 90: A Case for Ossification of the Base Layer",
    path: "/bitcoin-tech-page-90",
  },
];

const IndexPageBitcoinTech = () => {
  // State for staggered animation
  const [visibleItems, setVisibleItems] = useState([]);
  // State for hover tracking
  const [hoveredIndex, setHoveredIndex] = useState(null);

  // Custom title text for the secondary title
  const titleText = "Fundamentals of Bitcoin Tech";

  // Staggered animation effect
  useEffect(() => {
    pages.forEach((_, index) => {
      const delay = 50 * index;
      const timeoutId = setTimeout(() => {
        setVisibleItems((prevItems) => [...prevItems, index]);
      }, delay);
      return () => clearTimeout(timeoutId);
    });
  }, []);

  // Define the base style object for all links (matching IndexEconomics)
  const baseLinkStyle = {
    fontSize: "18px",
    width: "100%",
    padding: "15px 20px",
    margin: "0",
    textDecoration: "none",
    borderBottom: "1px solid #eee",
    color: "black",
    cursor: "pointer",
    textAlign: "left",
    transition:
      "color 0.3s ease, background-color 0.3s ease, transform 0.3s ease, opacity 0.5s ease, border-color 0.3s ease",
  };

  // Define the hover style (matching IndexEconomics)
  const hoverStyle = {
    backgroundColor: "#f9f9f9",
    color: "#034d28", // Dark Green text on hover
    transform: "translateX(5px)", // Subtle slide-right effect
    borderBottomColor: "#034d28", // Dark Green border on hover
  };

  return (
    <div
      style={{
        width: "95%",

        margin: "40px auto",
        padding: "0", // Remove padding to allow links to touch edges
        backgroundColor: "white",
        border: "2px solid #ccc",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
        overflowY: "auto",
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch", //
        fontFamily: "Georgia, sans-serif",
        lineHeight: "1.6",
        letterSpacing: "0.3px",
      }}
    >
      <h1
        style={{
          fontSize: "30px",
          fontWeight: "bold",
          textAlign: "center",
          marginBottom: "20px",
          marginTop: "20px",
          color: "black",
          padding: "0 20px", // Add padding back to the title
        }}
      >
        <b>Table of Contents</b>
        <br />
        <TypewriterText text={titleText} delay={80} />
      </h1>
      {pages.map((page, index) => {
        const isVisible = visibleItems.includes(index);
        const isHovered = hoveredIndex === index;

        return (
          <Link
            key={index}
            to={page.path}
            // Merge base style, animation style, and hover style
            style={{
              ...baseLinkStyle,
              // Animation style (fade in and slide up)
              ...(isVisible
                ? {}
                : { opacity: 0, transform: "translateY(20px)" }),
              // Hover style
              ...(isHovered ? hoverStyle : {}),
            }}
            // Hover handlers
            onMouseEnter={() => setHoveredIndex(index)}
            onMouseLeave={() => setHoveredIndex(null)}
          >
            {page.title}
          </Link>
        );
      })}
    </div>
  );
};

export default IndexPageBitcoinTech;
